export default "__VITE_ASSET__CHtV7bZh__"